export const CALC_MENU_LIST = {
  "Pressuring	the Opponent": {
    "Frame Trap Checker": {
      url: "frametrapchecker",
      desc: "Check the frame gap between two moves when the first is blocked",
      icon: "bulbOutline",
    },
    "Frame Trap Lister": {
      url: "frametraplister",
      desc: "Provide FAT with a number of frames, and it will generate a list of 2 move strings for you",
      icon: "receiptOutline",
    },
    "Frame Kill Generator": {
      url: "framekillgenerator",
      desc: "Automatically generate frame kills for a selection of oki scenarios",
      icon: "skullOutline",
      excludedGames: ["GGST", "2XKO"],
    },
  },
  "Punishing Moves": {
    "Move Punisher": {
      url: "movepunisher",
      desc: "Find out how to punish a specific move with your character",
      icon: "personRemoveOutline",
    },
    "Character Punisher": {
      url: "characterpunisher",
      desc: "See what your character's move can punish for a specific opponent",
      icon: "peopleOutline",
    },
  },
  Other: {
    "Move Linker": {
      url: "movelinker",
      desc: "See what a selected move can link to",
      icon: "linkOutline",
    },
    "String Interrupter": {
      url: "stringinterrupter",
      desc: "Figure out what moves you can push during a specific blockstring",
      icon: "handLeftOutline",
    },
  },
};